<app-header-four></app-header-four>

<div class="banner-wrapper banner-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="banner-wrapper-content">
                    <h1>Bienvenidos a la Fundación Acosta Ñu</h1>
                    <p>
                        Trabajamos con compromiso y solidaridad para brindar apoyo integral a familias de todos los departamentos del Paraguay.
                        Juntos construimos esperanza, acompañamiento y un futuro mejor para nuestra niñez.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- IMPACTO -->

<!--section class="outbreak-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Nuestro Impacto</span>
            <h2>Fundación Acosta Ñu en Acción</h2>
        </div>

        <div class="outbreak-content">
            <div class="outbreak-box-list">
                <div class="row">

                    <div class="col-lg-3 col-sm-6 col-md-6">
                        <div class="single-outbreak-box">
                            <div class="icon">
                                <img src="assets/img/icon5.png" alt="icon">
                            </div>
                            <h3 class="odometer" data-count="500">500</h3>
                            <p>Niños beneficiados</p>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6 col-md-6">
                        <div class="single-outbreak-box">
                            <div class="icon">
                                <img src="assets/img/icon5.png" alt="icon">
                            </div>
                            <h3 class="odometer" data-count="300">120</h3>
                            <p>Familias apoyadas</p>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6 col-md-6">
                        <div class="single-outbreak-box">
                            <div class="icon">
                                <img src="assets/img/icon5.png" alt="icon">
                            </div>
                            <h3 class="odometer" data-count="120">200</h3>
                            <p>Actividades solidarias</p>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6 col-md-6">
                        <div class="single-outbreak-box">
                            <div class="icon">
                                <img src="assets/img/icon5.png" alt="icon">
                            </div>
                            <h3 class="odometer" data-count="80">100s</h3>
                            <p>Voluntarios activos</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section-->
<section class="about-area-two ptb-100">
    <div class="container">

        <!-- QUIENES SOMOS -->
        <div class="row align-items-center">
            <div class="col-lg-6">
                <img src="assets/img/about-img4.jpg" alt="Fundación Acosta Ñu">
            </div>
            <div class="col-lg-6">
                <h2>¿Quiénes somos?</h2>

                <p><strong>FUNDACIÓN "ACOSTA ÑU"</strong><br>
                Personería Jurídica P.E. N° 7.290</p>
                <p>
                    La Fundación Acosta Ñu, bajo el régimen de protocolización jurídica, es una entidad sin fines de lucro, 
                    con patrimonio propio e independiente. Tiene como finalidad impulsar y promocionar seminarios, simposios, 
                    cursos, conferencias, congresos en el ámbito nacional e internacional, así como jornadas de actualización 
                    en modalidades presenciales y electrónicas, a través de actividades, proyectos y servicios.
                </p>

                <p>
                    Las capacitaciones multidisciplinarias sirven como apoyo profesional en los distintos ámbitos socioculturales, 
                    fortaleciendo al individuo en sus capacidades mediante el conocimiento, y consolidando criterios sólidos que 
                    garanticen la actualización permanente en el ámbito educativo y profesional, tanto civil como castrense.
                </p>
            </div>
        </div>

        <!-- MISION -->
        <div class="row align-items-center mt-5">
            <div class="col-lg-6">
                <h2>Nuestra Misión</h2>

                <p>
                    Brindar formación integral y apoyo profesional mediante programas de capacitación, fomentando valores, 
                    conocimientos y habilidades que contribuyan al desarrollo social, cultural y económico de sus miembros 
                    y de la comunidad.
                </p>

                <ul>
                    <li>Capacitación profesional multidisciplinaria</li>
                    <li>Organización de eventos académicos y formativos</li>
                    <li>Fortalecimiento de valores y liderazgo</li>
                    <li>Apoyo al desarrollo sociocultural</li>
                </ul>

                <p>
                    Asimismo, el Centro de Ex Cadetes tiene como misión estimular la solidaridad y los vínculos de camaradería 
                    entre sus asociados, mejorando su condición social, cultural y económica conforme a sus estatutos.
                </p>
            </div>
            <div class="col-lg-6">
                <img src="assets/img/about-img5.jpg" alt="Misión Fundación">
            </div>
        </div>

        <!-- VISION -->
        <div class="row align-items-center mt-5">
            <div class="col-lg-6">
                <img src="assets/img/about-img6.jpg" alt="Visión Fundación">
            </div>
            <div class="col-lg-6">
                <h2>Nuestra Visión</h2>

                <p>
                    Ser una institución referente a nivel nacional e internacional en formación, capacitación y desarrollo 
                    integral, generando impacto positivo en la sociedad mediante el conocimiento y los valores.
                </p>

                <p>
                    Promover convenios con instituciones afines y consolidar una comunidad comprometida con la excelencia, 
                    basada en los principios del "Ser, del Hacer y del Saber Hacer".
                </p>

                <p>
                    La formación de valores y calidad intelectual constituye una herramienta fundamental para el cambio de 
                    mentalidad y el desarrollo sostenible de las personas.
                </p>
            </div>
        </div>

    </div>
</section>
<!-- ACCIONES -->
<section class="prevention-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Participa</span>
            <h2>¿Cómo puedes ayudar?</h2>
        </div>

        <div class="row">

            <div class="col-lg-6">
                <h3>Lo que puedes hacer</h3>

                <!--p><strong>Donar:</strong> Tu aporte mejora la vida de muchos niños.</p-->
                <p><strong>Difundir:</strong> Comparte nuestra misión.</p>
                <p><strong>Apoyar eventos:</strong> Sé parte de nuestras campañas.</p>
            </div>

            <div class="col-lg-6">
                <h3>Compromiso social</h3>

                <p>Evitar la indiferencia.</p>
                <p>Informarse sobre la causa.</p>
                <p>Participar activamente.</p>
                <p>Apoyar a quienes lo necesitan.</p>
            </div>

        </div>
    </div>
</section>

<!-- EQUIPO -->
<section class="doctors-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Equipo</span>
            <h2>Nuestros colaboradores</h2>
        </div>

        <div class="row">

            <div class="col-lg-4">
                <div class="single-doctors-box">
                    <img src="assets/img/doctors/img1.jpg">
                    <h3>Equipo de Voluntarios</h3>
                    <span>Comprometidos con la causa</span>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="single-doctors-box">
                    <img src="assets/img/doctors/img2.jpg">
                    <h3>Colaboradores</h3>
                    <span>Apoyo constante</span>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="single-doctors-box">
                    <img src="assets/img/doctors/img3.jpg">
                    <h3>Aliados</h3>
                    <span>Instituciones y empresas</span>
                </div>
            </div>

        </div>
    </div>
</section>

<!-- VALORES -->
<section class="symptoms-area pt-100">
    <div class="container">
        <div class="row align-items-center">

            <div class="col-lg-6">
                <img src="assets/img/symptoms-img.png">
            </div>

            <div class="col-lg-6">
                <h2>Nuestros Valores</h2>
                <ul>
                    <li>Solidaridad</li>
                    <li>Compromiso</li>
                    <li>Empatía</li>
                    <li>Responsabilidad</li>
                    <li>Transparencia</li>
                </ul>
            </div>

        </div>
    </div>
</section>

<!-- NOTICIAS -->
<section class="blog-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Noticias</span>
            <h2>Actividades recientes</h2>
        </div>

        <div class="row">

            <div class="col-lg-4">
                <div class="single-blog-post-item">
                    <img src="assets/img/blog/img1.jpg">
                    <h4>Lanzamiento del libro Memorias de los Fundadores y Forjadores del Centro de Ex Cadetes del Liceo Militar "Acosta Ñu"</h4>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="single-blog-post-item">
                    <img src="assets/img/blog/img2.jpg">
                    <h4>Presentación del  libro Memorias de los Fundadores y Forjadores del Centro de Ex Cadetes del Liceo Militar "Acosta Ñu"</h4>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="single-blog-post-item">
                    <img src="assets/img/blog/img3.jpg">
                    <h4>Libro Memorias de los Fundadores y Forjadores del Centro de Ex Cadetes del Liceo Militar "Acosta Ñu"</h4>
                </div>
            </div>

        </div>
    </div>
</section>